import {PIG_COLOR} from "../components/farm-map-components/patterns/utils";
import {isNil} from "lodash";
import moment from "moment";
import {REMOVE_TECHNOLOGY_GROUP_REASONS} from "../utils/TechnologyGroupUtils";
import sowState from "./sowState";
import {removeReasonCodeToTranslationKey} from "../views/new-farm-view/tabs/results-renderers/ResultsReportFormatters";
import i18n from "../i18n";

const SOW_IDLE_DAYS = `WITH stateCTE AS (SELECT AnmID, value as state FROM ParamsTable WHERE key = 'sowState' AND isPresent = true AND value = '${sowState.IDLE}'),
daysCTE AS (SELECT AnmID, value FROM ParamsTable WHERE key = 'idleDays' AND isPresent = true AND value::INTEGER >= ? AND actCycle = true)
SELECT * FROM stateCTE INNER JOIN daysCTE on stateCTE.AnmID = daysCTE.AnmID`;
const SOW_AFTER_EXPECTED_FARROWING =
    "SELECT AnmID FROM ParamsTable WHERE key='expectedFarrowing' AND actCycle=true AND date_diff('day', today(), cast(value as DATE)) <= -? AND isPresent = true";
const SOW_BEFORE_EXPECTED_FARROWING =
    "SELECT AnmID FROM ParamsTable WHERE key='expectedFarrowing' AND actCycle=true AND date_diff('day', today(), cast(value as DATE)) <= ? AND isPresent = true";
const SOW_REPETITIONS =
    "SELECT AnmID FROM(SELECT AnmID, MAX(CASE WHEN key = 'repetition' THEN value ELSE NULL END)::INTEGER AS repetition, MAX(CASE WHEN key = 'bornPiglet' THEN value ELSE NULL END) AS bornPiglet, MIN(CASE WHEN key = 'usgResult' THEN value ELSE NULL END) AS usgResult FROM ParamsTable WHERE actCycle=true AND isPresent = true GROUP BY group_nr, AnmID, AnmNo1, actCycle) as S0 WHERE usgResult IS NULL AND bornPiglet IS NULL AND repetition>= 2";
const SOW_BEFORE_DELAYED_AFTER_PARTURITION =
    "SELECT * FROM(SELECT AnmID, SUM(TRY_CAST(value AS INTEGER)) FILTER(WHERE key = 'weanedPerCycleFarrow') AS weanedPerCycleFarrow, date_diff('day', today(), MIN(TRY_CAST(value AS DATE)) FILTER(WHERE key = 'expectedFarrowing'))::INTEGER AS expectedFarrowing, SUM(TRY_CAST(value AS INTEGER)) FILTER(WHERE key = 'shiftFarrowDay') AS shiftFarrowDay FROM ParamsTable WHERE actCycle=true AND isPresent = true GROUP BY group_nr, AnmID, AnmNo1, actCycle) as S0 WHERE (expectedFarrowing <= 7 OR shiftFarrowDay IS NOT NULL) AND weanedPerCycleFarrow IS NULL";
const SOW_EXPECTED_TRANSFER =
    "SELECT AnmID FROM ParamsTable WHERE key = 'nextTransfer' AND isPresent = true AND date_diff('day', today(), cast(value as DATE)) < 0";
const SOW_WITHOUT_PIGLETS =
    "SELECT s1.AnmID FROM (SELECT AnmID, value as days FROM ParamsTable WHERE key = 'zeroPigletsDays' AND actCycle = true AND isPresent = true) as s1 INNER JOIN (SELECT AnmID FROM ParamsTable WHERE key = 'currentSector' AND actCycle = true AND isPresent = true AND value = 4) as s2 ON s1.AnmID = s2.AnmID";
const SOW_WRONG_CYCLE =
    "WITH main as (SELECT cycle::INTEGER as cycle, AnmID, COUNT(AnmID) FILTER(WHERE key = 'liveBornPiglet') > 0 as hadParturition, COUNT(CASE WHEN key = 'weanedPiglet' THEN AnmID END) > 0 as hadWeaning, COUNT(CASE WHEN key = 'boar' THEN AnmID END) > 0 as hadInsemination FROM ParamsTable WHERE isPresent = true GROUP BY AnmID, cycle) SELECT AnmID FROM (SELECT s1.AnmID, s1.hadInsemination, s2.hadParturition, s2.hadWeaning FROM (SELECT * FROM main) as s1 INNER JOIN (SELECT * FROM main) as s2 ON CONCAT(s1.AnmID, '_', s1.cycle - 1) = CONCAT(s2.AnmID, '_', s2.cycle)) WHERE hadInsemination = true AND hadParturition = true AND hadWeaning = false";
const SOW_WITH_PIGLETS =
    "SELECT * FROM (SELECT SUM(CASE WHEN key IN ('liveBornPiglet', 'fostering') THEN value::INTEGER ELSE -value::INTEGER END) as value, AnmID FROM ParamsTable WHERE actCycle = true AND key IN ('liveBornPiglet', 'deadPiglet', 'weanedPiglet', 'fostering') GROUP BY AnmID) WHERE value > 0";
const SOW_IN_TECHNOLOGY_GROUP_HISTORICAL = `
    SELECT AnmID,
           ANY_VALUE(AnmNo1) as AnmNo1,
           LAST(value) FILTER(WHERE key = 'technologyGroupRemoval' ) as removeReason
    FROM ParamsTable
    WHERE group_nr = ? AND key IN ('technologyGroupRemoval', 'boar')
    GROUP BY AnmID
    ORDER BY AnmNo1
`;
const SOW_IN_TECHNOLOGY_GROUP = `
    SELECT *
    FROM (${SOW_IN_TECHNOLOGY_GROUP_HISTORICAL})
    WHERE removeReason IS NULL
`;
const SOW_MARKED_FOR_CULLING = `SELECT AnmID FROM ParamsTable WHERE key = 'markedForCulling' AND isPresent = true`;
const SOW_IDLE_DAYS_ANIMALS = `WITH stateCTE AS (SELECT AnmNo1, AnmID, value as state FROM ParamsTable WHERE key = 'sowState' AND isPresent = true AND value = '${sowState.IDLE}'),
daysCTE AS (SELECT AnmID, value FROM ParamsTable WHERE key = 'idleDays' AND isPresent = true AND value::INTEGER >= ? AND actCycle = true)
SELECT * FROM stateCTE INNER JOIN daysCTE on stateCTE.AnmID = daysCTE.AnmID WHERE stateCTE.AnmID IN ? ORDER BY stateCTE.AnmNo1 ASC`;
const SOW_AFTER_EXPECTED_FARROWING_ANIMALS =
    "SELECT AnmID, date_diff('day', today(), cast(value as DATE)) as value FROM ParamsTable WHERE key='expectedFarrowing' AND actCycle=true AND date_diff('day', today(), cast(value as DATE)) <= -? AND isPresent = true AND AnmID IN ? ORDER BY AnmNo1 ASC";
const SOW_BEFORE_EXPECTED_FARROWING_ANIMALS =
    "SELECT AnmID, date_diff('day', today(), cast(value as DATE)) as value FROM ParamsTable WHERE key='expectedFarrowing' AND date_diff('day', today(), cast(value as DATE)) <= ? AND actCycle=true AND isPresent = true AND AnmID IN ? ORDER BY AnmNo1";
const SOW_REPETITIONS_ANIMALS =
    "SELECT * FROM(SELECT AnmID, MAX(CASE WHEN key = 'repetition' THEN value ELSE NULL END)::INTEGER AS repetition, MAX(CASE WHEN key = 'bornPiglet' THEN value ELSE NULL END) AS bornPiglet, MIN(CASE WHEN key = 'usgResult' THEN value ELSE NULL END) AS usgResult FROM ParamsTable WHERE actCycle=true AND isPresent = true AND AnmID IN ? GROUP BY group_nr, AnmID, AnmNo1, actCycle ORDER BY AnmNo1) as S0 WHERE usgResult IS NULL AND bornPiglet IS NULL AND repetition>= 2";
const SOW_BEFORE_DELAYED_AFTER_PARTURITION_ANIMALS =
    "SELECT * FROM(SELECT AnmID, SUM(TRY_CAST(value AS INTEGER)) FILTER(WHERE key = 'weanedPerCycleFarrow') AS weanedPerCycleFarrow, date_diff('day', today(), MIN(TRY_CAST(value AS DATE)) FILTER(WHERE key = 'expectedFarrowing'))::INTEGER AS expectedFarrowing, SUM(TRY_CAST(value AS INTEGER)) FILTER(WHERE key = 'shiftFarrowDay') AS shiftFarrowDay FROM ParamsTable WHERE actCycle=true AND isPresent = true AND AnmID IN ? GROUP BY group_nr, AnmID, AnmNo1, actCycle ORDER BY AnmNo1) as S0 WHERE (expectedFarrowing <= 7 OR shiftFarrowDay IS NOT NULL) AND weanedPerCycleFarrow IS NULL";
const SOW_EXPECTED_TRANSFER_ANIMALS =
    "SELECT AnmID, ABS(date_diff('day', today(), cast(value as DATE))) as days FROM ParamsTable WHERE key = 'nextTransfer' AND isPresent = true AND date_diff('day', today(), cast(value as DATE)) < 0 AND AnmID IN ? ORDER BY AnmNo1";
const SOW_WITHOUT_PIGLETS_ANIMALS =
    "SELECT * FROM (SELECT AnmNo1, AnmID, value as days FROM ParamsTable WHERE key = 'zeroPigletsDays' AND actCycle = true AND isPresent = true AND AnmID IN ?) as s1 INNER JOIN (SELECT AnmID FROM ParamsTable WHERE key = 'currentSector' AND actCycle = true AND isPresent = true AND value = 4) as s2 ON s1.AnmID = s2.AnmID ORDER BY s1.AnmNo1";
const SOW_WRONG_CYCLE_ANIMALS =
    "WITH main as (SELECT cycle::INTEGER as cycle, AnmID, LAST(AnmNo1) as AnmNo1, COUNT(CASE WHEN key = 'liveBornPiglet' THEN AnmID END) > 0 as hadParturition, COUNT(CASE WHEN key = 'weanedPiglet' THEN AnmID END) > 0 as hadWeaning, COUNT(CASE WHEN key = 'boar' THEN AnmID END) > 0 as hadInsemination FROM ParamsTable WHERE isPresent = true AND AnmID IN ? GROUP BY AnmID, cycle) SELECT AnmID, AnmNo1 FROM (SELECT s1.AnmNo1, s1.AnmID, s1.hadInsemination, s2.hadParturition, s2.hadWeaning FROM (SELECT * FROM main) as s1 INNER JOIN (SELECT * FROM main) as s2 ON CONCAT(s1.AnmID, '_', s1.cycle - 1) = CONCAT(s2.AnmID, '_', s2.cycle)) WHERE hadInsemination = true AND hadParturition = true AND hadWeaning = false ORDER BY AnmNo1";
const SOW_WITH_PIGLETS_ANIMALS =
    "SELECT * FROM (SELECT SUM(CASE WHEN key IN ('liveBornPiglet', 'fostering') THEN value::INTEGER ELSE -value::INTEGER END) as value, AnmID, ANY_VALUE(AnmNo1) as AnmNo1 FROM ParamsTable WHERE actCycle = true AND AnmID IN ? AND key IN ('liveBornPiglet', 'deadPiglet', 'weanedPiglet', 'fostering') GROUP BY AnmID) WHERE value > 0 ORDER BY AnmNo1";
const SOW_IN_TECHNOLOGY_GROUP_HISTORICAL_ANIMALS = `
    SELECT AnmID,
           ANY_VALUE(AnmNo1) as AnmNo1,
           FIRST(value) FILTER(WHERE key = 'technologyGroupRemoval') as removeReason, 
           LAST(group_nr) as group_nr
    FROM ParamsTable
    WHERE group_nr = ? AND AnmID IN ? AND key IN ('technologyGroupRemoval', 'boar')
    GROUP BY AnmID
    ORDER BY AnmNo1
`;
const SOW_MARKED_FOR_CULLING_ANIMALS = `SELECT AnmID, epoch_ms(dataEv) as markedDate, value FROM ParamsTable WHERE key = 'markedForCulling' AND isPresent = true AND AnmID IN ? ORDER BY AnmNo1`;

export const SOW_IN_TECHNOLOGY_GROUP_ANIMALS = `
    SELECT *
    FROM (${SOW_IN_TECHNOLOGY_GROUP_HISTORICAL_ANIMALS})
    WHERE removeReason IS NULL
`;
export const mapSQL = {
    // lista zapytan dla mapy
    SOW_IDLE_DAYS,
    SOW_AFTER_EXPECTED_FARROWING,
    SOW_BEFORE_EXPECTED_FARROWING,
    SOW_REPETITIONS,
    SOW_BEFORE_DELAYED_AFTER_PARTURITION,
    SOW_EXPECTED_TRANSFER,
    SOW_WITHOUT_PIGLETS,
    SOW_WRONG_CYCLE,
    SOW_WITH_PIGLETS,
    SOW_IN_TECHNOLOGY_GROUP,
    SOW_IN_TECHNOLOGY_GROUP_HISTORICAL,
    SOW_MARKED_FOR_CULLING,
};

export const mapSQLColors = {
    SOW_IDLE_DAYS: PIG_COLOR.ERROR,
    SOW_REPETITIONS: ({value}) =>
        value === 2 ? PIG_COLOR.WARN : PIG_COLOR.ERROR,
    SOW_BEFORE_DELAYED_AFTER_PARTURITION: ({
        expectedFarrowing,
        shiftFarrowDay,
    }) =>
        shiftFarrowDay !== null
            ? PIG_COLOR.INFO
            : expectedFarrowing >= 0
              ? PIG_COLOR.SUCCESS
              : PIG_COLOR.ERROR,
    SOW_EXPECTED_TRANSFER: PIG_COLOR.ERROR,
    SOW_WITHOUT_PIGLETS: PIG_COLOR.ERROR,
    SOW_WRONG_CYCLE: PIG_COLOR.ERROR,
    SOW_IN_TECHNOLOGY_GROUP: PIG_COLOR.SUCCESS,
    SOW_IN_TECHNOLOGY_GROUP_HISTORICAL: ({removeReason}) => {
        if (isNil(removeReason)) {
            return PIG_COLOR.SUCCESS;
        }
        if (removeReason === REMOVE_TECHNOLOGY_GROUP_REASONS.SEPARATION) {
            return PIG_COLOR.INFO;
        }
        return PIG_COLOR.WARN;
    },
    SOW_MARKED_FOR_CULLING: PIG_COLOR.WARN,
};

export const animalListMapSQL = {
    // lista zapytan dla komponentow wyswietlajacych zapytania na mapie, gdzie nazwa jest identyczna, aby je powiazac w latwy sposob (odwracanie obiektow)
    SOW_IDLE_DAYS: SOW_IDLE_DAYS_ANIMALS,
    SOW_AFTER_EXPECTED_FARROWING: SOW_AFTER_EXPECTED_FARROWING_ANIMALS,
    SOW_BEFORE_EXPECTED_FARROWING: SOW_BEFORE_EXPECTED_FARROWING_ANIMALS,
    SOW_REPETITIONS: SOW_REPETITIONS_ANIMALS,
    SOW_BEFORE_DELAYED_AFTER_PARTURITION:
        SOW_BEFORE_DELAYED_AFTER_PARTURITION_ANIMALS,
    SOW_EXPECTED_TRANSFER: SOW_EXPECTED_TRANSFER_ANIMALS,
    SOW_WITHOUT_PIGLETS: SOW_WITHOUT_PIGLETS_ANIMALS,
    SOW_WRONG_CYCLE: SOW_WRONG_CYCLE_ANIMALS,
    SOW_WITH_PIGLETS: SOW_WITH_PIGLETS_ANIMALS,
    SOW_IN_TECHNOLOGY_GROUP: SOW_IN_TECHNOLOGY_GROUP_ANIMALS,
    SOW_IN_TECHNOLOGY_GROUP_HISTORICAL:
        SOW_IN_TECHNOLOGY_GROUP_HISTORICAL_ANIMALS,
    SOW_MARKED_FOR_CULLING: SOW_MARKED_FOR_CULLING_ANIMALS,
};

export const animalListMapFields = {
    SOW_IDLE_DAYS: [{translationKey: "sterilleDays", field: "value"}],
    SOW_AFTER_EXPECTED_FARROWING: [
        {translationKey: "daysAfterExpectedParturition", field: "value"},
    ],
    SOW_BEFORE_EXPECTED_FARROWING: [
        {translationKey: "daysBeforeParturition", field: "value"},
    ],
    SOW_REPETITIONS: [{translationKey: "grid.repetition", field: "repetition"}],
    SOW_BEFORE_DELAYED_AFTER_PARTURITION: [
        {
            translationKey: "expectedParturitionIn",
            field: "expectedFarrowing",
        },
        {
            translationKey: "expectedRealParturitionDelay",
            field: "shiftFarrowDay",
        },
    ],
    SOW_EXPECTED_TRANSFER: [
        {translationKey: "delayWithDaysUnit", field: "days"},
    ],
    SOW_WITHOUT_PIGLETS: [
        {translationKey: "daysWithoutPiglets", field: "days"},
    ],
    SOW_WRONG_CYCLE: [],
    SOW_WITH_PIGLETS: [{translationKey: "pigletsAmount", field: "value"}],
    SOW_IN_TECHNOLOGY_GROUP: [],
    SOW_IN_TECHNOLOGY_GROUP_HISTORICAL: [
        {
            translationKey: "removeFromGroupReason",
            field: "removeReason",
            valueFormatter: (value) => {
                if (!value) return null;
                const [code] = value.split("_");
                const key = removeReasonCodeToTranslationKey(+code);
                return i18n.t(key);
            },
        },
    ],
    SOW_MARKED_FOR_CULLING: [
        {
            translationKey: "date",
            field: "markedDate",
            valueFormatter: (value) =>
                value ? moment(value).format("L") : null,
        },
        {
            translationKey: "reason",
            field: "value",
        },
    ],
};
